import { DYNAMIC_PAGE_TYPES, STATIC_ROUTES } from '../utils/constants';
import { slugify } from './slugify.cjs';

export const getDynamicPageLink = (type, pageName, pageId) => {
  switch (type) {
    case DYNAMIC_PAGE_TYPES.JURY_FILTER:
      return STATIC_ROUTES.JUROR_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.COMPANY_FILTER:
      return STATIC_ROUTES.COMPANY_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.PROJECT_FILTER:
      return STATIC_ROUTES.PROJECT_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.SP_FILTER:
      return STATIC_ROUTES.SP_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.STUDENT_FILTER:
      return STATIC_ROUTES.STUDENT_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.EVENT_FILTER:
      return STATIC_ROUTES.EVENT_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.COMPANY_DETAIL:
      return `${STATIC_ROUTES.COMPANY_DETAIL}/${slugify(pageName)}/${pageId}`;
    case DYNAMIC_PAGE_TYPES.PROJECT_DETAIL:
      return `${STATIC_ROUTES.PROJECT_DETAIL}/${slugify(pageName)}/${pageId}`;
    case DYNAMIC_PAGE_TYPES.JURY_DETAIL:
      return `${STATIC_ROUTES.JUROR_DETAIL}/${slugify(pageName)}/${pageId}`;
    case DYNAMIC_PAGE_TYPES.EVENT_DETAIL:
      return `${STATIC_ROUTES.EVENT_DETAIL}/${slugify(pageName)}/${pageId}`;
    case DYNAMIC_PAGE_TYPES.EDITORIAL_FILTER:
      return STATIC_ROUTES.EDITORIAL_FILTER_PAGE;
    case DYNAMIC_PAGE_TYPES.RANKING_FILTER:
      return STATIC_ROUTES.WDI_FILTER_PAGE;
    default:
      return null;
  }
};
